import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        fires: null || JSON.parse(localStorage.getItem('fires')),
        currentFire: null,
        errorDialog: false,
        errorDialogMessages: [],
        successDialog: false,
        successDialogTitle: '',
        successDialogMessage: '',
    },

    mutations: {
      change(state, fire) {

          let fires = JSON.parse(localStorage.getItem('fires'));
          if(fires == undefined) {
            fires = [];
          }
          fires.push(fire);

          localStorage.setItem('fires', JSON.stringify(fires));

          state.fires = fires;

          console.log("qua tutti i fires: " + JSON.stringify(state.fires))
      },
      setCurrentFire (state, fire) {
        state.currentFire = fire;
      }
    },

    getters: {
      fires: state => state.fires,
      currentFire: state => state.currentFire,
      errorDialog: state => state.errorDialog,
      errorDialogMessages: state => state.errorDialogMessages,
      successDialog: state => state.successDialog,
      successDialogTitle: state => state.successDialogTitle,
      successDialogMessage: state => state.successDialogMessage,
  }
})


export default store;
